import { API_HOST, AXIOS_INSTANCE } from './api'
import axios from 'axios'

const LOGIN_ENDPOINT = "login";
const LOGOUT_ENDPOINT = "logout";
const REGISTER_ENDPOINT = "register";
const FORGOT_ENDPOINT = "forgot-password";
const VERIFY_ENDPOINT = "forgot-password/verify";
const RECOVER_ENDPOINT = "recover-password";

export async function USER_LOGIN(form) {
    const response = await axios.post(`${API_HOST}/${LOGIN_ENDPOINT}`, form, {
      headers: {
        'Accept': 'application/json'
      }
    });
    return response.data;
}

export async function USER_LOGOUT(form) {
    const response = await axios.post(`${API_HOST}/${LOGOUT_ENDPOINT}`, form, {
        headers: {
          'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
          'Accept': 'application/json'
        }
    });
    return response.data;
}

export async function POST_USER(form) {
    const response = await axios.post(`${API_HOST}/${REGISTER_ENDPOINT}`, form, {
      headers: {
        'Accept': 'application/json'
      }
    });
    return response.data;
}

export async function FORGOT_PASSWORD(form) {
    const response = await axios.post(`${API_HOST}/${FORGOT_ENDPOINT}`, form);
    return response.data;
}

export async function VERIFY_FORGOT_PASSWORD(form) {
    const response = await axios.get(`${API_HOST}/${VERIFY_ENDPOINT}?email=${form.email}&token=${form.token}`);
    return response.data;
}

export async function RECOVER_PASSWORD(form) {
    const response = await axios.post(`${API_HOST}/${RECOVER_ENDPOINT}`, form);
    return response.data;
}



// WEBPACK FOOTER //
// ./src/services/user.js